import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../actions";
import moment from "moment";
import { useNavigate } from "react-router-dom";
// import { Datepicker } from "flowbite-react";
import Datepicker from "react-tailwindcss-datepicker";
import { SearchDropdown } from "../inputs";
import { axiosGet } from "../../util/axios";
import { UserAvatar } from "../user_avatar";

function Activity({ uid, type }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const activites = useSelector((state) => state.activity.activites?.data);
  const currentPage = useSelector(
    (state) => state.activity.activites?.current_page
  );
  const totalPage = useSelector(
    (state) => state.activity.activites?.total_pages
  );

  const pageRef = useRef();

  const fetchActivities = () => {
    if (uid) {
      dispatch(
        actions.GETACTIVITY_REQ({
          limit: 10,
          page: currentPage + 1,
          uid: uid,
          ...dateFilter,
          "filter.coworker": coworkerFilter?.coworker_uid,
          type,
        })
      );
    }
  };

  const [dateFilter, setDateFilter] = useState({});
  const [coworkerFilter, setCoworkerFilter] = useState();
  const [coworkersList, setCoworkersList] = useState([]);

  const handleDateChange = (date) => {
    setDateFilter(date);
    pageRef.current = 0;
    dispatch(
      actions.GETACTIVITY_REQ({
        limit: 10,
        uid: uid,
        page: 1,
        ...date,
        "filter.coworker": coworkerFilter?.coworker_uid,
        type,
      })
    );
  };

  const applyCoworkerFilter = (coworker) => {
    setCoworkerFilter(coworker);
    pageRef.current = 0;
    dispatch(
      actions.GETACTIVITY_REQ({
        limit: 10,
        uid: uid,
        page: 1,
        ...dateFilter,
        type,
        "filter.coworker": coworker?.coworker_uid,
      })
    );
  };

  useEffect(() => {
    pageRef.current = 0;
    dispatch(
      actions.GETACTIVITY_REQ({
        limit: 10,
        uid: uid,
        page: 1,
        // date: moment().format("YYYY-MM-DD"),
        type,
      })
    );
  }, []);

  useEffect(() => {
    setLoading(false);
  }, [activites]);

  const pageHandling = (next) => {
    if (!loading) {
      setLoading(true);
      fetchActivities();
    }
  };

  const redirectToCoworker = (coworker_uid) => {
    navigate(`/coworkers/${coworker_uid}/details`);
  };

  useEffect(() => {
    console.log(coworkersList);
  }, [coworkersList]);
  return (
    <div className="h-full mt-3">
      <div className="relative h-full w-full bg-white rounded-lg shadow px-4">
        <div className="p-2 h-full">
          <div className="flow-root h-full">
            <div className="h-full -mx-4 -my-2 sm:-mx-6 lg:-mx-8">
              <div className="h-full inline-block min-w-full py-4 align-middle sm:px-6 lg:px-8">
                <div className="mx-auto pb-5 border-b flex felx-row items-center sm:flex sm:items-center sm:justify-between">
                  <h3 className="text-lg font-semibold leading-6 text-gray-900">
                    Recent Activity
                  </h3>
                  <div className="flex justify-end items-center flex-1 px-3 gap-x-4">
                    {type === "CUSTOMER" && (
                      <SearchDropdown
                        remote
                        className="mb-1.5 text-gray-700"
                        value={coworkerFilter?.coworker_uid}
                        options={coworkersList}
                        optionId="coworker_uid"
                        optionName="fullName"
                        searchplaceholder="Start typing coworker name"
                        nullLabel="All Coworkers"
                        debounce
                        optionPrefix={(coworker) => {
                          return (
                            <UserAvatar
                              className="inline border-2 rounded-full [&_img]:h-8 [&_img]:w-8 [&_svg]:h-8 [&_svg]:w-8"
                              user={coworker}
                            />
                          );
                        }}
                        onSelect={(value) => {
                          applyCoworkerFilter(value);
                        }}
                        onSearch={(keyword) => {
                          if (keyword) {
                            axiosGet(
                              `${process.env.REACT_APP_BACKEND_URL}/coworkers?filter.keyword=${keyword}`
                            ).then(({ data: res }) => {
                              let _coworkersList = [];
                              console.log(coworkerFilter);
                              if (coworkerFilter?.coworker_uid) {
                                _coworkersList.push({
                                  ...coworkerFilter,
                                });
                              }
                              res.data.forEach((_coworker) => {
                                _coworker.coworker_uid !==
                                  coworkerFilter?.coworker_uid &&
                                  _coworkersList.push(_coworker);
                              });
                              setCoworkersList([..._coworkersList]);
                            });
                          } else {
                            coworkerFilter?.coworker_uid &&
                              setCoworkersList([coworkerFilter]);
                          }
                        }}
                      />
                    )}
                    <div id="datepicker-wrapper">
                      <Datepicker
                        classNames={{
                          footer: (p) => `
                              px-2
                              pb-2
                              [&_button:first-of-type]:!bg-white
                              [&_button:first-of-type]:!rounded-md
                              [&_button:first-of-type]:!shadow-sm
                              [&_button:first-of-type]:!disabled:bg-gray-200
                              [&_button:first-of-type]:!disabled:opacity-50
                              [&_button:first-of-type]:!text-gray-900
                              [&_button:first-of-type]:!font-semibold
                              [&_button:first-of-type]:!ring-gray-300
                              [&_button:first-of-type:hover]:!bg-gray-50
                              [&_button:first-of-type]:!ring-1
                              [&_button:first-of-type]:!ring-inset
                              [&_button]:w-[100px]
                              [&_button]:ml-auto
                              [&_button]:cursor-pointer
                              [&_button]:bg-gray-800
                              [&_button]:rounded-md
                              [&_button]:shadow-sm
                              [&_button]:disabled:bg-gray-500
                              [&_button]:disabled:opacity-75
                              [&_button]:text-white
                              [&_button]:font-semibold
                              [&_button:hover]:bg-gray-600
                              [&_button:focus-visible]:outline-gray-600
                              [&_button:focus-visible]:outline
                              [&_button:focus-visible]:outline-2
                              [&_button:focus-visible]:outline-offset-2`,
                        }}
                        containerClassName={(p) => `
                              relative w-full text-gray-700
                              [&_.bg-indigo-100]:!bg-gray-100
                              [&_.bg-indigo-500]:!bg-gray-800
                              [&_.line-through]:text-gray-200
                      `}
                        placeholder="Apply date filter"
                        primaryColor="indigo"
                        value={dateFilter}
                        onChange={handleDateChange}
                        showFooter
                        useRange
                        maxDate={new Date()}
                        startFrom={moment().subtract("30", "days").toDate()}
                        displayFormat="DD-MM-YYYY"
                        popoverDirection="down"
                      />
                    </div>
                  </div>
                </div>

                <ol class="relative border-l border-gray-200 mt-5 dark:border-gray-700">
                  {activites?.map((data) => (
                    <li class="mb-3 ml-4">
                      <div class="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -left-1.5 border border-white dark:border-gray-900 dark:bg-gray-700"></div>
                      <time class="mb-1 text-sm font-normal leading-none text-gray-400 dark:text-gray-500">
                        {moment().diff(data.created_at, "days") === 0
                          ? moment(data.created_at).fromNow()
                          : moment(data.created_at).format(
                              "DD-MM-YYYY - hh:mm A"
                            )}
                      </time>
                      {/* <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
                        
                      </h3> */}
                      <p class="text-base font-normal text-gray-600 dark:text-gray-400">
                        <b
                          className="text-indigo-500 cursor-pointer"
                          onClick={() => redirectToCoworker(data?.coworker_uid)}
                        >
                          {data?.coworkers?.name} -{" "}
                        </b>
                        {data?.remarks}
                      </p>
                    </li>
                  ))}
                </ol>

                {activites.length === 0 && (
                  <div className="w-full h-full flex justify-center items-center text-sm text-gray-500">
                    No activites
                  </div>
                )}

                {currentPage < totalPage && (
                  <div
                    onClick={() => {
                      pageHandling();
                    }}
                    className="mt-2 p-5 hover:text-blue-600 text-indigo-500 underline text-center cursor-pointer border-gray-300 rounded-lg bg-gray-50 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700"
                  >
                    {loading ? "loading ..." : "load more"}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Activity;
